import "../../../../css/modal/UserRegisterModal.css";
import "../../../../css/modal/ModalInput.css";
import UserListInfo from "../../../../utils/UserListInfo";
import LocationCode from "../../../../utils/constants/LocationCode";
import FunnelCode from "../../../../utils/constants/FunnelCode";
import Gender from "../../../../utils/constants/Gender";
import { getDateString, limitInputNumber, setInvalidMessage, checkValidDateWithPattern, moveModal } from "../../../../utils/Utils";
import { useRef, useState } from "react";
import proxy from "../../../../utils/Proxy";

let UserRegisterModal = (props) => {
    let ref = useRef(null)
    let [validBirth, setValidBirth] = useState(true)
    let [submitted, setSubmitted] = useState(false)

    let checkValidBirth = () => {
        let valid = checkValidDateWithPattern("user-edit-input-birth-year", "user-edit-input-birth-month", "user-edit-input-birth-day")
        setValidBirth(valid)

        if (!valid) {
            document.getElementById("user-edit-invalid-message-birth").innerHTML = UserListInfo.InvalidMessage[3];
            return false;
        }
        else {
            document.getElementById("user-edit-invalid-message-birth").innerHTML = "";
            return true;
        }

    }
    let onChangeBirth = (e, limit) => {
        limitInputNumber(e, limit);
        checkValidBirth();
    }

    let registerUser = () => {
        let dialogResult = window.confirm("등록 하시겠습니까?");
        if (!dialogResult) return;

        setSubmitted(true);
        // valid check
        let invalidList = []
        for (let i = 0; i <= UserListInfo.registerLastIndex; i++) {
            let name = UserListInfo.detailDataName[i];
            if (name === "location" || name === "howto" || name === "gender") {
                let validityTarget = document.getElementsByName("user-edit-input-" + name)[0]
                let valid = validityTarget.validity.valid;
                if (!valid) invalidList.push(UserListInfo.detailLabel[i]);
                setInvalidMessage(validityTarget, "user-edit-invalid-message-" + name, UserListInfo.InvalidMessage[i])
                continue;
            }


            if (name === "birth") {
                if (!checkValidBirth()) invalidList.push(UserListInfo.detailLabel[i]);
                continue;
            }

            let validityTarget = document.getElementById("user-edit-input-" + name)
            let valid = validityTarget.validity.valid;
            if (!valid) invalidList.push(UserListInfo.detailLabel[i]);

            // setting invalid message
            setInvalidMessage(validityTarget, "user-edit-invalid-message-" + name, UserListInfo.InvalidMessage[i])
        }

        let validityTarget = document.getElementById("user-edit-input-password1")
        let valid = validityTarget.validity.valid;
        if (!valid) invalidList.push("비밀번호");
        setInvalidMessage(validityTarget, "user-edit-invalid-message-password1", "4글자 이상 입력해주세요.")
        validityTarget = document.getElementById("user-edit-input-password2")
        valid = validityTarget.validity.valid;
        if (!valid) invalidList.push("비밀번호 확인");
        setInvalidMessage(validityTarget, "user-edit-invalid-message-password2", "비밀번호가 일치하지않습니다.")

        if (invalidList.length > 0) {
            let message = "";
            for (let invalid of invalidList)
                message += invalid + ", ";
            message = message.slice(0, -2)

            window.alert("잘못된 형식입니다.\n(" + message + ")");

            return;
        }

        // read input data
        let body = {};

        for (let i = 0; i <= UserListInfo.registerLastIndex; i++) {
            let name = UserListInfo.detailDataName[i];
            let keyword = "user-edit-input-" + name;
            switch (name) {
                case "location":
                case "gender":
                case "howto":
                    let radioList = document.getElementsByName(keyword);
                    for (let j = 0; j < radioList.length; j++) {
                        if (radioList[j].checked) {
                            body[name] = j;
                            break;
                        }
                    }
                    break;
                case "birth":
                    let year = document.getElementById("user-edit-input-birth-year").value
                    let month = document.getElementById("user-edit-input-birth-month").value
                    let day = document.getElementById("user-edit-input-birth-day").value
                    let birth = new Date(year, month - 1, day);
                    body[name] = getDateString(birth);
                    break;
                default:
                    body[name] = document.getElementById(keyword).value;
            }
        }
        body["password"] = document.getElementById("user-edit-input-password1").value;
        proxy.post("/adminapi/users/", body).then((result) => {
            window.alert("등록되었습니다.");
            props.onRegister(() => {
                return result.data.insertId;
            });
        }).catch(res => {
            window.alert(res.response.data.message)
        });
    }

    let cancelRegister = () => {
        let dialogResult = window.confirm("취소 하시겠습니까?")
        if (dialogResult)
            props.onCloseClick()
    }
    let passwordChange = (e) => {
        setInvalidMessage(e.target, "user-edit-invalid-message-password1", "4글자 이상 입력해주세요.")
        let passwordConfirm = document.getElementById("user-edit-input-password2")
        passwordConfirm.pattern = e.target.value;
        if (passwordConfirm.validity.valid)
            setInvalidMessage(passwordConfirm, "user-edit-invalid-message-password2", "비밀번호가 일치하지 않습니다.");
    }
    let passwordConfirmChange = (e) => {
        setInvalidMessage(e.target, "user-edit-invalid-message-password2", "비밀번호가 일치하지 않습니다.");
    }

    return (
        <div className="modal-container">
            <div className="modal" id="user-register-modal" ref={ref}>
                <div className="modal-content-container">
                    <div className="modal-header" onMouseDown={e => moveModal(e, "user-register-modal")}>
                        <p className="modal-title">
                            수강생 등록
                        </p>
                        <div className="modal-close-button" onClick={cancelRegister}></div>
                    </div>
                    <div className="modal-content">
                        {UserListInfo.detailLabel.map((label, index) => {
                            if (index > UserListInfo.registerLastIndex) return null;
                            let input = <></>

                            switch (label) {
                                case "수강 지점":
                                    input = (
                                        <div className="modal-input-radio-container">
                                            {LocationCode.text.map((location, innerIndex) => {
                                                return (
                                                    <label className="modal-input-radio-label" key={"editUserLocation" + innerIndex}>
                                                        <input type="radio" name="user-edit-input-location" value={innerIndex}
                                                            onClick={(e) => setInvalidMessage(e.target, "user-edit-invalid-message-" + UserListInfo.detailDataName[index], UserListInfo.InvalidMessage[index])} required />
                                                        <p>{location}</p>
                                                    </label>
                                                )
                                            })}
                                        </div>
                                    )

                                    break;
                                case "성별":
                                    input = (
                                        <div className="modal-input-radio-container">
                                            <label className="modal-input-radio-label">
                                                <input type="radio" name="user-edit-input-gender" value="0" required />
                                                <p>{Gender.text[0]}</p>
                                            </label>
                                            <label className="modal-input-radio-label">
                                                <input type="radio" name="user-edit-input-gender" value="1" required />
                                                <p>{Gender.text[1]}</p>
                                            </label>
                                        </div>
                                    )
                                    break;
                                case "방문경로":
                                    input = (
                                        <div className="modal-input-radio-container">
                                            {FunnelCode.text.map((funnel, innerIndex) => {
                                                return (
                                                    <label className="modal-input-radio-label" key={"editUserFunnel" + innerIndex}>
                                                        <input type="radio" name="user-edit-input-howto" value={innerIndex}
                                                            onClick={(e) => setInvalidMessage(e.target, "user-edit-invalid-message-" + UserListInfo.detailDataName[index], UserListInfo.InvalidMessage[index])} required />
                                                        <p>{funnel}</p>
                                                    </label>
                                                )
                                            })}
                                        </div>
                                    )
                                    break;
                                case "생년월일":
                                    input = (
                                        <div className={!submitted || validBirth ?
                                            "modal-input" : "modal-input-invalid"}>
                                            <input className="modal-input-date" id="user-edit-input-birth-year"
                                                onChange={e => onChangeBirth(e, 4)}
                                                onBlur={e => onChangeBirth(e, 4)}
                                                pattern="\d{4}" required></input>
                                            <p>-</p>
                                            <input className="modal-input-date" id="user-edit-input-birth-month"
                                                onChange={e => onChangeBirth(e, 2)}
                                                onBlur={e => onChangeBirth(e, 2)}
                                                pattern="0?[1-9]|1[0-2]" required></input>
                                            <p>-</p>
                                            <input className="modal-input-date" id="user-edit-input-birth-day"
                                                onChange={e => onChangeBirth(e, 2)}
                                                onBlur={e => onChangeBirth(e, 2)}
                                                pattern="0?[1-9]|[1-2][0-9]|3[0-1]" required></input>
                                        </div>
                                    )
                                    break;
                                case "주소":
                                    input = (
                                        <input className={"modal-input" + (submitted ? " modal-input-submitted" : "")}
                                            id={"user-edit-input-" + UserListInfo.detailDataName[index]}
                                            onChange={e => { setInvalidMessage(e.target, "user-edit-invalid-message-" + UserListInfo.detailDataName[index], UserListInfo.InvalidMessage[index]) }}
                                            onBlur={e => { setInvalidMessage(e.target, "user-edit-invalid-message-" + UserListInfo.detailDataName[index], UserListInfo.InvalidMessage[index]) }}
                                            defaultValue="부산광역시"
                                            pattern={UserListInfo.detailEditRegex[index]} required></input>

                                    )
                                    break;
                                case "피아노 경력":
                                case "희망장르":
                                    input = (
                                        <input className={"modal-input" + (submitted ? " modal-input-submitted" : "")}
                                            id={"user-edit-input-" + UserListInfo.detailDataName[index]}></input>
                                    )
                                    break;
                                default:
                                    input = (
                                        <input className={"modal-input" + (submitted ? " modal-input-submitted" : "")}
                                            id={"user-edit-input-" + UserListInfo.detailDataName[index]}
                                            onChange={e => { setInvalidMessage(e.target, "user-edit-invalid-message-" + UserListInfo.detailDataName[index], UserListInfo.InvalidMessage[index]) }}
                                            onBlur={e => { setInvalidMessage(e.target, "user-edit-invalid-message-" + UserListInfo.detailDataName[index], UserListInfo.InvalidMessage[index]) }}
                                            pattern={UserListInfo.detailEditRegex[index]} required></input>
                                    )

                            }
                            return (
                                <div className="modal-content-item-container" key={"detail-modal-" + index}>
                                    <div className="modal-content-item modal-content-align-start">
                                        <div className="modal-content-divider-2">
                                            <p className="modal-content-text">{label}</p>
                                        </div>
                                        <div className="modal-content-divider-2">
                                            <div className="modal-input-container">
                                                {input}
                                                <p className="modal-input-invalid-message"
                                                    id={"user-edit-invalid-message-" + UserListInfo.detailDataName[index]}></p>
                                            </div>
                                        </div>
                                    </div>
                                    {label === "로그인 아이디" ?
                                        <>
                                            <div className="modal-content-item modal-content-align-start">
                                                <div className="modal-content-divider-2">
                                                    <p className="modal-content-text">비밀번호</p>
                                                </div>
                                                <div className="modal-content-divider-2">
                                                    <div className="modal-input-container">
                                                        <input className={"modal-input" + (submitted ? " modal-input-submitted" : "")}
                                                            id="user-edit-input-password1"
                                                            type="password"
                                                            onChange={passwordChange}
                                                            onBlur={e => { setInvalidMessage(e.target, "user-edit-invalid-message-password1", "4글자 이상 입력해주세요.") }}
                                                            pattern={".{4,}"} required></input>
                                                        <p className="modal-input-invalid-message" id="user-edit-invalid-message-password1"></p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="modal-content-item modal-content-align-start">
                                                <div className="modal-content-divider-2">
                                                    <p className="modal-content-text">비밀번호 확인</p>
                                                </div>
                                                <div className="modal-content-divider-2">
                                                    <div className="modal-input-container">
                                                        <input className={"modal-input" + (submitted ? " modal-input-submitted" : "")}
                                                            id="user-edit-input-password2"
                                                            type="password"
                                                            onChange={passwordConfirmChange}
                                                            onBlur={passwordConfirmChange}
                                                            pattern={""} required></input>
                                                        <p className="modal-input-invalid-message" id="user-edit-invalid-message-password2"></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </> : null}
                                </div>
                            )
                        })}
                    </div>
                    <div className="modal-footer">
                        <div className="modal-footer-button-container">
                            <div className="modal-button" onClick={registerUser}>
                                <p>등록</p>
                            </div>
                            <div className="modal-button" onClick={cancelRegister}>
                                <p>취소</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UserRegisterModal;